import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { auth, db } from "../../../firebase/firebaseConfig";

function getActorName(user) {
  return user?.displayName || user?.email || "Giáo viên";
}

export async function logClassActivity({
  classId,
  type = "class_update",
  message,
  severity = "normal",
  actorId,
  actorName,
  targetId = null,
  targetTitle = "",
  metadata = {},
}) {
  if (!classId || !message) return null;

  const user = auth.currentUser;

  return addDoc(collection(db, "class_activities"), {
    classId,
    type,
    message,
    severity,
    actorId: actorId || user?.uid || null,
    actorName: actorName || getActorName(user),
    targetId,
    targetTitle,
    metadata,
    createdAt: serverTimestamp(),
  });
}
